import React from 'react';
import { graphql } from "gatsby";
import PropTypes from 'prop-types';
import ContentBlock from '../../components/contentBlock/contentBlock';
import StructuredText from '../../components/structuredText/structuredText';
import ModuleWrapper from '../../globals/moduleWrapper/moduleWrapper';

/**
 * CMS Component: DatoCmsModuleTextContent
 * 
 */
const TextContent = ({data, className, ...other}) => {
    const {anchor, backgroundColor, border, contentType, copySize, content, ...contentBlock} = data || {};
    let hasVideoClass = '';
    // console.log('content', content);
    if(content?.blocks){
      hasVideoClass = content?.blocks.some( element => element?.__typename === "DatoCmsComponentVideo" ) ? 'narrowContent' : '';
    }

    return (
    <ModuleWrapper anchor={anchor} border={border} className={`textContent ${className || ''} textContent--${contentType ? 'inline' : 'conclusion'} ${backgroundColor?.hex === '#262626' ? 'Reversed': 'Default'}`} {...other} style={{'background': backgroundColor?.hex}}>
      <ContentBlock data={contentBlock} className={`${hasVideoClass}`}/>
      <StructuredText data={content} className={`${hasVideoClass} contentBlock--${copySize || 'Default'}`} />
    </ModuleWrapper>
    );
};

TextContent.propTypes = {
  /**
  * Data from cms
  */
  data: PropTypes.shape({
    anchor: PropTypes.string,
    backgroundColor: PropTypes.object,
    border: PropTypes.oneOf(['', 'None', 'Gradient Border Bottom', 'Gradient Border Top', 'Lifted Top', 'Lifted Bottom', 'Lifted Fully']),

    contentType: PropTypes.bool,
    content: PropTypes.object,
    copySize: PropTypes.oneOf(['', 'Default', 'Featured', 'Secondary']),
    heading: PropTypes.string,
    images : PropTypes.array,
    subheading: PropTypes.string
  }),
  className: PropTypes.string,
};

export default TextContent;

export const ModuleTextContentFragment = graphql`
fragment ModuleTextContentFragment on DatoCmsModuleTextContent {
   
  anchor
  toggleId
  backgroundColor{
    hex
  }
  border
  contentType
  content{
    blocks{
      __typename
      ...ImageLayoutFragment
      ...LinkFragment
      ...VideoFragment
      ...ImageLinkCollectionFragment
      ...MobileDesktopVersionFragment
    }
    links
    value
  }
  copySize
  heading
  subheading
}
`;